import { ReactNode } from 'react';
import Disclosure from '~/components/Disclosure';
import Icon from '~/components/Icon';

export default function ReturnSummaryDisclosure({
  label,
  value,
  children,
  defaultOpen = false,
}: {
  label: ReactNode;
  value?: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  return (
    <Disclosure
      hideIndicator
      defaultOpen={defaultOpen}
      summary={
        <div className="flex w-full items-center justify-between gap-1">
          <div className="flex items-center gap-1">
            {label}
            <Icon
              icon="ChevronRight"
              className="size-3 transition-transform group-open:rotate-90"
            />
          </div>

          {value && <span>{value}</span>}
        </div>
      }
    >
      <div className="mt-2">{children}</div>
    </Disclosure>
  );
}
